export default "__VITE_ASSET__CXos41an__"